import { BibliothequeChampignonsBrowse } from '@repo/ui/features/bibliotheque/champignons-browse';

export default function BibliothequeChampignonsPage() {
  return <BibliothequeChampignonsBrowse />;
}

